module.exports = __webpack_public_path__ + "static/media/catalogue.776b42d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/main/catalogue.png
// module id = 64
// module chunks = 0